import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addFrelitOrder, getFrelitOrders } from "../../api/frelitOrder.api";
import { IFrelitOrder } from "../../models/FrelitOrderData.model";

interface OrderState {
  loading: boolean;
  error: string | null;
  orders: IFrelitOrder[];
}

const initialState: OrderState = {
  loading: false,
  error: null,
  orders: [],
};

export const NewFrelitOrder = createAsyncThunk(
  "frelitOrder/addFrelitOrder",
  async (
    orderData: {
      goods: { productId: string; quantity: number }[];
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addFrelitOrder(orderData);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchFrelitOrders = createAsyncThunk(
  "frelitOrder/getFrelitOrders",
  async (_, { rejectWithValue }) => {
    try {
      const ordersData = await getFrelitOrders();
      return ordersData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


const frelitorderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(NewFrelitOrder.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(NewFrelitOrder.fulfilled, (state, action) => {
      state.loading = false;
      // Extract the order data from the response
      const orderData = action.payload.data?.order || action.payload;
      state.orders.unshift(orderData); // Add new order at beginning
    });
    builder.addCase(NewFrelitOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
    builder.addCase(fetchFrelitOrders.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchFrelitOrders.fulfilled, (state, action) => {
      state.loading = false;
      // Ensure we're using the direct array of orders
      state.orders = Array.isArray(action.payload)
        ? action.payload
        : action.payload.data || [];
    });
    builder.addCase(fetchFrelitOrders.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default frelitorderSlice.reducer;
